import React from 'react';
import CircleImage from '../circle-image';
import defaultUserLogo from '../../assets/svg/SvgProfile.svg?url';

const UserCircleImage = ({ image, className, useState, SSR, method }) => {
    return <CircleImage image={image || defaultUserLogo} {...{ className, useState, SSR, method }} />;
};

export default UserCircleImage;
